import { render, staticRenderFns } from "./GroupEditAddModal.vue?vue&type=template&id=40266521&"
import script from "./GroupEditAddModal.vue?vue&type=script&lang=js&"
export * from "./GroupEditAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports